// src/utils/Timestamp.ts
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

class TimestampUtils {
  /**
   * Formats a timestamp from ISO format to "hh:mm A" format
   * If timestamp is already in "hh:mm A" format, returns it as is
   */
  formatTimestamp(timestamp?: string | null): string | null {
    if (!timestamp) return null

    // If already in hh:mm A format, return as is
    if (timestamp.match(/^\d{1,2}:\d{2} [AP]M$/)) {
      return timestamp
    }

    // Try parsing as ISO string
    try {
      return dayjs(timestamp).format('hh:mm A')
    } catch (error) {
      console.error('Error formatting timestamp:', error)
      return null
    }
  }

  /**
   * Gets current timestamp in hh:mm A format
   */
  getCurrentTimestamp() {
    const now = dayjs()
    return {
      hours: now.format('hh'),
      minutes: now.format('mm'),
      period: now.format('A'),
    }
  }

  /**
   * Converts a timestamp in "hh:mm A" format to ISO format
   * Uses current date as the date portion
   */
  convertToISOTimestamp(timestamp?: string | null): string | null {
    if (!timestamp) return null
    const today = dayjs().format('YYYY-MM-DD')
    const dateTime = dayjs(`${today} ${timestamp}`, 'YYYY-MM-DD hh:mm A')
    return dateTime.toISOString()
  }

  /**
   * Validates if a string is in "hh:mm A" format
   */
  isValidTimeFormat(time: string): boolean {
    return /^\d{1,2}:\d{2} [AP]M$/.test(time)
  }
}

export const timestampUtils = new TimestampUtils()
